<div class="row link-list-section">
  <div class="col-lg-8">
    <h2 class="link-list__title" *scText="title()"></h2>
    @if (showIntroduction() && introduction(); as introduction) {
      <wl-rich-text-wrapper [field]="introduction">
        <div class="link-list__introduction"></div>
      </wl-rich-text-wrapper>
    }
  </div>
</div>

<div class="link-list__grid" [attr.link-lists]="linkLists().length">
  @for (linkList of linkLists(); track linkList.id) {
    <wl-link-list
      [id]="linkList.id"
      [title]="linkList.title"
      [linkList]="linkList.links"
      class="w-100"
    />
  }
</div>
